// EchoPlay developer-portal contract.
//
// Echo Engine documentation is hosted by the EchoPlay portal, not by this app.
// The in-app route is a menu that links out to the regional portal deployments.
// Every entry is absolute HTTPS — the portal is a different origin, so relative
// links and protocol-relative URLs are not valid here.

import type { LocalizedText } from './locale';

/** Path the Echo Engine portal is mounted at on every regional host. */
export const PORTAL_PATH = '/echoengine';

export const PORTAL_REGION_IDS = ['asia', 'west', 'east'] as const;
export type PortalRegionId = (typeof PORTAL_REGION_IDS)[number];

export interface PortalRegion {
  id: PortalRegionId;
  /** Absolute HTTPS URL of the regional portal. */
  url: string;
  host: string;
  name: LocalizedText;
  description: LocalizedText;
}

/**
 * Regional portal deployments, in menu order. `east` is the apex host and acts
 * as the global default; `asia` and `west` are regional mirrors of the same
 * corpus.
 */
export const PORTAL_REGIONS: readonly PortalRegion[] = [
  {
    id: 'asia',
    url: 'https://asia.echoplay.ai/echoengine',
    host: 'asia.echoplay.ai',
    name: { en: 'Asia', zh: '亚洲' },
    description: {
      en: 'Asia-Pacific mirror of the Echo Engine developer portal.',
      zh: 'Echo Engine 开发者门户的亚太镜像。',
    },
  },
  {
    id: 'west',
    url: 'https://west.echoplay.ai/echoengine',
    host: 'west.echoplay.ai',
    name: { en: 'West', zh: '西部' },
    description: {
      en: 'Western-region mirror of the Echo Engine developer portal.',
      zh: 'Echo Engine 开发者门户的西部区域镜像。',
    },
  },
  {
    id: 'east',
    url: 'https://echoplay.ai/echoengine',
    host: 'echoplay.ai',
    name: { en: 'East', zh: '东部' },
    description: {
      en: 'Eastern-region portal on the apex host; the global default.',
      zh: '位于主域名的东部区域门户，也是全局默认入口。',
    },
  },
];
